module.exports = __webpack_public_path__ + "static/img/3.d047806.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/3.png
// module id = 5Bp/
// module chunks = 0